// components/ActivityInsights/SVGLineChart.js

export default function SVGLineChart({ data, width = 200, height = 60 }) {

  const paddingTop = 6;
  const paddingBottom = 4;
  const chartHeight = height - paddingTop - paddingBottom;

  const max = Math.max(
    ...data.map(d => Math.max(d.bookings, d.utilisation))
  );

  const step = width / (data.length - 1);

  const buildPath = (key) => {
    return data.map((d, i) => {
      const x = i * step;
      const y =
        paddingTop +
        (chartHeight - (d[key] / max) * chartHeight);

      return `${i === 0 ? "M" : "L"} ${x} ${y}`;
    }).join(" ");
  };

  const bookingsPath = buildPath("bookings");
  const utilisationPath = buildPath("utilisation");

  return (
	<div style={{paddingTop:'10px'}}>
    <svg width={width} height={height}>

      {/* Bookings (RED) */}
      <path
        d={bookingsPath}
        fill="none"
        stroke="#ef4444"
        strokeWidth={2}
      />

      {/* Utilisation (ORANGE) */}
      <path
        d={utilisationPath}
        fill="none"
        stroke="#f59e0b"
        strokeWidth={2}
      />

    </svg>
	</div>
  );
}